export default __webpack_public_path__ + "static/media/lightMode_logo.086817a0.svg";